import Fantastic from "./Fantastic";

export default Fantastic;
